var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section"},[_c('h1',[_vm._v("Page not found")]),_vm._v(" "),_c('div',[_c('p',{staticClass:"lead"},[_vm._v("Sorry! The content you tried to access could not be found.")])])])])
}]

export { render, staticRenderFns }